<nav class="sidebar">
  <mat-nav-list>
    <a mat-list-item routerLink="/dashboard" routerLinkActive="active" *ngIf="auth.temMenu('/dashboard')">
      <mat-icon matListItemIcon>dashboard</mat-icon>
      <span matListItemTitle>Dashboard</span>
    </a>

    <a mat-list-item routerLink="/acoes-judiciais" routerLinkActive="active" *ngIf="auth.temMenu('/acoes-judiciais')">
      <mat-icon matListItemIcon>gavel</mat-icon>
      <span matListItemTitle>Ações Judiciais</span>
    </a>

    <a mat-list-item routerLink="/solicitacoes" routerLinkActive="active" *ngIf="auth.temMenu('/solicitacoes')">
      <mat-icon matListItemIcon>assignment</mat-icon>
      <span matListItemTitle>Solicitações</span>
    </a>

    <a mat-list-item routerLink="/ocorrencias" routerLinkActive="active" *ngIf="auth.temMenu('/ocorrencias')">
      <mat-icon matListItemIcon>history</mat-icon>
      <span matListItemTitle>Ocorrências</span>
    </a>

    <a mat-list-item routerLink="/caixa-entrada" routerLinkActive="active" *ngIf="auth.temMenu('/caixa-entrada')">
      <mat-icon matListItemIcon>inbox</mat-icon>
      <span matListItemTitle>Caixa de Entrada</span>
    </a>		
    <a mat-list-item routerLink="/relatorios/status" routerLinkActive="active" *ngIf="auth.temMenu('/relatorios/status')">
	  <mat-icon matListItemIcon>bar_chart</mat-icon>
	  <span matListItemTitle>Relatório por Status</span>
	</a>
	<a mat-list-item routerLink="/relatorios/pendentes" routerLinkActive="active" *ngIf="auth.temMenu('/relatorios/pendentes')">
	  <mat-icon matListItemIcon>pending_actions</mat-icon>
	  <span matListItemTitle>Pendentes por Usuário</span>
	</a>
    <a mat-list-item routerLink="/vinculos-email-unidade" routerLinkActive="active" *ngIf="auth.temMenu('/vinculos-email-unidade')">
      <mat-icon matListItemIcon>alternate_email</mat-icon>
      <span matListItemTitle>Vínculo E-mail/Unidade</span>
    </a>
  </mat-nav-list>
</nav>